import request from '@/utils/request'
import qs from 'qs'

// 查询列表
export function getList(query) {
  return request({
    url: '/dianjiang/orderSetting/listDate',
    method: 'get',
    params: query
  })
}
// 加急详情
export function getDetail(id) {
  return request({
    url: '/dianjiang/orderSetting/exigencysDetail/' + id,
    method: 'get'
  })
}

// 新增
export function addList(data) {
  return request({
    url: '/dianjiang/orderSetting/addExigency',
    method: 'post',
    data: data
  })
}

//修改加急设置
export function updateList(data) {
  return request({
    url: '/dianjiang/orderSetting/editExigency',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: qs.stringify(data)
  })
}

// 删除加急设置
export function delList(data) {
  return request({
    url: '/dianjiang/orderSetting/delExigencys',
    method: 'get',
    params: data
  })
}
